import React from "react";
import {Grid, Box, Select, Tooltip} from "@mui/material";
import { TopMarketsAvailableMetrics } from "../../Utils/AvailableMetrics";
import MenuItem from "@mui/material/MenuItem";
import { formatValue } from "features/new-homepage/Utils/FormatMetricValue";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { DecreaseIcon, IncreaseIcon } from "assets/images/Icons";
import { arrowIcon } from "features/new-homepage/DeviceComponent/TableDevice";

const formatMetricValue = (value) => {
    if (value === null || value === undefined || value === "") return "0";
    
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return value;
    
    if (numValue % 1 === 0) {
        return numValue.toString();
    }
    
    return numValue.toFixed(2).replace(/\.?0+$/, '');
};

// Add function to check if metric needs currency symbol
const needsCurrencySymbol = (metric) => {
    const currencyMetrics = ['cost', 'generated', 'cpc'];
    return currencyMetrics.includes(metric);
};

function TopMarketsTable({
    marketOption,
    selectedMarkets,
    topMarketsMetrics,
    selectedOption,
    handleMarketOptionChange,
    handleDropdownChange,
}) {

    
    // Helper function to render market rows
    const renderMarketRows = (markets, startIndex = 0) => {
        return markets.map((market, index) => (
            <Box key={`market-${startIndex + index}`} className="market-row">
                <Box className="market-name" key={`market-${startIndex + index}-name`}>
                    {market.market_name}
                </Box>
                <Box className="market-value" key={`market-${startIndex + index}-value`}>
                    {market?.compare_enabled && <Tooltip
                        title={`${needsCurrencySymbol(marketOption) ? topMarketsMetrics.currency_symbol : ''}${formatMetricValue(market[`${marketOption}_kpi_compare`])}`}
                    >
                        <span
                            style={{
                                color:
                                    market[`${marketOption}_kpi_compare_percent`] <
                                    0
                                        ? "red"
                                        : "green",
                            }}
                        >
                            {arrowIcon(
                                market[`${marketOption}_kpi_compare_percent`] < 0
                            )}{" "}
                            {market[`${marketOption}_kpi_compare_percent`]}%
                        </span>
                    </Tooltip>}
                    {formatValue(
                        `${marketOption}_kpi`,
                        market,
                        topMarketsMetrics.currency_symbol
                    )}
                </Box>
            </Box>
        ));
    };
    
    // Optimized chunk logic - directly slice arrays without intermediate chunks
    const markets = selectedMarkets || [];
    const firstFiveMarkets = markets.slice(0, 5);
    const lastFiveMarkets = markets.slice(5, 10);
    
    return (
      <Grid item xs={12} className="top-markets-table-container">
        <Grid container>
          <Grid item xs={12}>
            <Box className="top-markets-table-header">
              <Box className="option-container">
                TOP PERFORMING MARKETS
                <Select
                  value={marketOption}
                  onChange={(e) => handleMarketOptionChange(e.target.value)}
                  variant="outlined"
                  displayEmpty
                  sx={{
                    color: "black",
                    fontSize: "12px",
                    padding: "0",
                    border: "none",
                    fontWeight: 600,
                    height: "28px",
                    background: "transparent",
                    display: "flex",
                    fontFamily: "Inter",
                    "& .MuiSelect-icon": {
                      color: "#BAB7B7",
                    },
                    "& .MuiSelect-select": {
                      padding: 0,
                    },
                    "& fieldset": {
                      border: "none",
                      padding: 0,
                    },
                  }}
                >
                  {Object.entries(TopMarketsAvailableMetrics).map(
                    ([key, label]) => (
                      <MenuItem
                        key={key}
                        value={key}
                        sx={{
                          fontSize: "12px",
                          padding: "4px 8px",
                          lineHeight: "1.2",
                          fontFamily: "Inter",
                        }}
                      >
                        {label}
                      </MenuItem>
                    )
                  )}
                </Select>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              {/* First 5 Markets */}
              <Grid item xs={6} className="top-markets-table">
                {firstFiveMarkets.length > 0 ? (
                  renderMarketRows(firstFiveMarkets)
                ) : (
                  <Box className="market-row no-data">No Data Available</Box>
                )}
              </Grid>

              {/* Last 5 Markets */}
              <Grid item xs={6} className="top-markets-table">
                {lastFiveMarkets.length > 0 && renderMarketRows(lastFiveMarkets, 5)}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
}

export default TopMarketsTable;
